<template >
    <div id="app">
        <div class="content">

            <div class="col-charts">
                <h1 class="title is-4">{{siteName}}</h1>
                <h4>Environment</h4>
                <div class="graph-container height">
                    <plotly-plot :data="environmentData" :config="config" :layout="layout2" v-on:zoom="zoomChange" />
                </div>
            </div>

            <div class="target-graphs">
                <template v-for="target in selectedTargets" >
                        <div :key="target.id">
                            <h4>{{target.description}}</h4>
                            <div class="graph-container"><plotly-plot :data="target.data" :config="config" :layout="layout3" v-on:zoom="zoomChange" /></div>
                        </div>
                </template>

            </div>
        </div>
    </div>
</template>


<script lang="js">


import PlotlyPlot from "../components/PlotlyPlot.vue"
import Vue from "vue"
import { client } from '@/util';
import { isLoggedIn } from '../client';

export default Vue.extend({
    data() {
        return {
            deployment: null,
            environmentData: [],
            siteName: '',
            LoggedIn: false,
            config: {
                displayLogo: false,
                displayModeBar: false,
            },
            layout3: {
                xaxis: { fixedrange: true, autorange: false}, 
                yaxis: { fixedrange: true, side: 'left', title: 'Kilo copies of <br> target DNA'},
                showlegend: false,
                margin: {"t": 0, "b": 30 },
                height: 180,
                barmode: "stack"
                },
            layout: {
                xaxis: { fixedrange: true, autorange: false}, 
                yaxis: { fixedrange: true, side: 'left', title: 'No. Insects <br> Observed'},
                showlegend: false,
                margin: {"t": 0, "b": 30 },
                height: 170,
                barmode: "stack"
                },
            layout2: {
                xaxis: { fixedrange: true, autorange: false}, 
                yaxis: { fixedrange: true, side: 'left', title: "\u00B0C/mm" },
                yaxis2: { fixedrange: true, side: 'right', title: '%RH', overlaying: "y" },
                showlegend: false,
                margin: {"t": 0, "b": 30 },
                height: 150,
                barmode: "stack"
            },
            targets: [],
            selectedTargets: [],
            originalRange: []
        }
    },
    computed: {
        deploymentId() { return this.$route.params.id },
    },
    created() {
        client.post("/public/deployment/id/" + this.deploymentId).then((result) => {
            this.deployment = result.data.deployment;
            this.siteName = result.data.deployment.site_name;
            this.layout.xaxis.range = [this.deployment.start_date, this.deployment.end_date]
            this.layout2.xaxis.range = [this.deployment.start_date, this.deployment.end_date]
            this.layout3.xaxis.range = [this.deployment.start_date, this.deployment.end_date]
            this.originalRange=[this.deployment.start_date, this.deployment.end_date]
                    console.log(this.isPublic);

            this.LoggedIn = isLoggedIn();
            if (this.LoggedIn && this.isPublic !== true){
                this.isPublic = true;
            }

            client.post("/public/graph/deployment/" + this.deploymentId + "/environment").then((result) => {
                this.environmentData = result.data.series;
            });

            this.loadMyrtle();

        })
    },
    // mounted(){
    // },
    components: {
        PlotlyPlot
    },
    methods: {
        loadMyrtle() {
           const data = {
                        "targetId": 41,
                        "startDate": this.deployment.start_date,
                        "endDate": this.deployment.end_date,
                        "sentinelId": this.deployment.sentinel_id
           }

            client.post("/public/graph/pathogen", data).then((result) => {

                const target = {
                    "target_type_id": 2,
                    description: "Myrtle Rust"
                };
                
                target.data = result.data.series;

                target.hasData = target.data.map(series => series["y"].some(item => item > 0))
                    .some(x => x);
                
                this.selectedTargets.push(target);
                
            });

        },

        zoomChange() {
            this.layout.xaxis.range = this.originalRange
            this.layout = Object.assign({}, this.layout);
        }

    },
})

</script>
<style lang="scss" scoped>

.target-graphs {
    margin-top: 50px;
}

@media only screen and (max-width: 768px) {
    .content {
        margin: 5px;
    }
}

@media only screen and (min-width: 768px) {
    .content {
        margin: 50px 100px 50px 100px;
    }
}





</style>


